export const gameVersion: string = '9.1'

export const mtDate = {
  day: 22,
  month: 10,
  year: 2026,
}
